export enum IntegrationType {
  DISPATCHERS = 'dispatchers',
  ENRICHMENTS = 'enrichments',
  THIRD_PARTY_CONSENT = 'third_party_consent',
}

export enum IntegrationChannel {
  AMADEUS = 'amadeus',
  EMAIL = 'email',
  MIGRATION = 'migration',
  RCS = 'rcs',
  SMS = 'sms',
  WHATSAPP = 'whatsapp',
}

export enum IntegrationName {
  AMADEUS = 'Amadeus',
  REVIEWS = 'Reviews',
  BULKSENDS = 'bulksends',
  EARLYBIRDS = 'earlybirds',
  LINKMOBILITYSMS = 'linkmobilitysms',
  LINKMOBILITYRCS = 'linkmobilityrcs',
  RECOMMENDATIONS = 'Recommendations',
  SES = 'sesgo',
  STUB = 'gostub',
  THIRD_PARTY_CONSENT = 'thirdpartyconsent',
  TRENDS = 'Trends',
  TRUSTPILOT = 'trustpilot',
  VOUCHER_CODES = 'Voucher Codes',
  WAX = 'wax',
}

export enum ReviewsProviders {
  bazaarvoice = 'Bazaarvoice',
}

export interface Integration {
  audit?: {
    lastUpdatedAt: number;
    lastUpdatedBy: string;
  };
  config: IntegrationConfig;
  enrichment: IntegrationName;
  id: string;
  siteId?: string;
  version: number;
  type?: IntegrationType;
  channel?: IntegrationChannel;
  consentGroup?: string;
}

export interface IntegrationResponse {
  id: string;
  ownerId: string;
  dispatcher: IntegrationName;
  config: DispatcherConfig;
  channel: IntegrationChannel;
}

export type IntegrationConfig = EnrichmentConfig & DispatcherConfig & ThirdPartyConsentConfig;

export type EnrichmentConfig = BazaarvoiceConfig &
  ReviewsConfig &
  EarlyBirdsConfig &
  TrustPilotConfig &
  RecommendationsConfig &
  TrendsConfig &
  VoucherCodesConfig &
  AmadeusConfig;

export type DispatcherConfig = StubConfig & SESGoConfig & LinkMobilitySMSConfig & LinkMobilityRCSConfig & WaxConfig;

export class StubConfig {}

export type ThirdPartyConsentConfig = KeringConfig;

export interface KeringConfig {
  id?: string;
  brandCode?: string;
  secret?: string;
}

export interface BazaarvoiceConfig {
  apiKey?: string;
  minRating?: number;
  provider?: string;
}

export interface ReviewsConfig {
  provider?: string;
}

export interface EarlyBirdsConfig {
  dataSource?: string;
  widgetKey?: string;
}

export interface RecommendationsConfig {
  siteId?: string;
  enrichmentVersion?: string;
}

export interface TrendsConfig {
  siteId?: string;
  enrichmentVersion?: string;
}

export interface VoucherCodesConfig {
  siteId?: string;
  enrichmentVersion?: string;
}

export interface TrustPilotConfig {
  businessUnitId?: string;
  locale?: string;
  apiKey?: string;
}

export interface SESGoConfig {
  configSet?: string;
  fromAddress?: string;
  fromName?: string;
  returnPath?: string;
  replyToAddresses?: string[];
}

export interface LinkMobilitySMSConfig {
  fromName?: string;
  apiKey?: string;
}

export interface LinkMobilityRCSConfig {
  fromName?: string;
  apiKey?: string;
}

export interface WaxConfig {
  webhookUrl?: string;
  authToken?: string;
  affiliateLink?: string;
  browseAnalyticsQuery?: string;
  cartAnalyticsQuery?: string;
}

export interface AmadeusConfig {
  clientId?: string;
  clientSecret?: string;
  clientUrl?: string;
}

export interface IntegrationsState {
  integrationsEnabled: boolean;
}
